import React from 'react';

import { Breadcrumb } from 'antd';
import styled from 'styled-components';

import { useAppSelector } from 'store/hook';

import ParentCommunitySelector from '../../../common/Community/ParentCommunitySelector';
import { useCommunityViewContext } from '../CommunityViewContext';

const StyledBreadcrumb = styled(Breadcrumb)`
  span {
    color: var(--text-primary);

    &.competitor {
      color: var(--competitor-purple);
    }

    &.terminal {
      color: var(--text-secondary);
    }
  }

  li {
    display: flex;
    align-items: center;
  }
`;

interface Props {
  community: any;
}

const CommunityViewHeaderBreadcrumbs = ({ community }: Props) => {
  const { selectedCommunity } = useAppSelector((state) => state.global);
  const { competitorId, view } = useCommunityViewContext();

  const isCompetitor = Boolean(competitorId);

  const items = [
    {
      className: isCompetitor ? 'competitor' : '',
      title: isCompetitor ? 'Competitor' : 'My Community',
    },
    {
      className: 'terminal',
      title: view?.name,
    },
  ];

  if (isCompetitor && (selectedCommunity?.parentCommunities ?? []).length > 1) {
    items.push({
      className: 'terminal',
      title: <ParentCommunitySelector />,
    });
  }
  return <StyledBreadcrumb items={items} separator="·" />;
};

export default CommunityViewHeaderBreadcrumbs;
